var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.74782C0 3.23832 1.85794 1.1196 4.35318 0.852376C7.96478 0.465602 13.1185 0 17 0C20.8815 0 26.0352 0.465602 29.6468 0.852376C32.1421 1.1196 34 3.23832 34 5.74783V28.0178C34 30.4549 32.2426 32.5353 29.829 32.8726C26.2153 33.3777 20.9598 34 17 34C13.0402 34 7.78473 33.3777 4.171 32.8726C1.75742 32.5353 0 30.4549 0 28.0178V5.74782Z",
    fill: "#F7E7D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 17.0002C17.5042 17.0002 17.9358 16.8206 18.2949 16.4616C18.6539 16.1026 18.8334 15.671 18.8334 15.1668C18.8334 14.6627 18.6539 14.2311 18.2949 13.872C17.9358 13.513 17.5042 13.3335 17.0001 13.3335C16.4959 13.3335 16.0643 13.513 15.7053 13.872C15.3463 14.2311 15.1667 14.6627 15.1667 15.1668C15.1667 15.671 15.3463 16.1026 15.7053 16.4616C16.0643 16.8206 16.4959 17.0002 17.0001 17.0002ZM17.0001 26.1668C14.5404 24.0738 12.7032 22.1297 11.4886 20.3345C10.274 18.5394 9.66675 16.8779 9.66675 15.3502C9.66675 13.0585 10.4039 11.2328 11.8782 9.87308C13.3525 8.51336 15.0598 7.8335 17.0001 7.8335C18.9404 7.8335 20.6477 8.51336 22.122 9.87308C23.5963 11.2328 24.3334 13.0585 24.3334 15.3502C24.3334 16.8779 23.7261 18.5394 22.5115 20.3345C21.297 22.1297 19.4598 24.0738 17.0001 26.1668Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2fd672610be209f404ee5a28f333fd49.svg";
export { ForwardRef as ReactComponent };